import FancyFilter from './FancyFilter';

export default FancyFilter;
